// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nbt11fZeH4x1XUJi4hYg {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./pages/Mark/pages/Drips/template.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B","sourcesContent":[".page {\n    width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export var page = `nbt11fZeH4x1XUJi4hYg`;
export default ___CSS_LOADER_EXPORT___;
